import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import * as fromUploader from '@app/client/uploader/store/reducers';
import { FileSystemMetadata } from '@app/shared/components/smash-file-drop/interfaces';
import { getPathWithoutLastFragment } from '@app/shared/helpers/location';
import { select, Store } from '@ngrx/store';
import { Observable, ReplaySubject, of } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PrepareGuard {

  constructor(
    private store$: Store<fromUploader.State>,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      this.router.navigateByUrl('/');
      return of(false);
    }
    return this.hasFile().pipe(map((hasFile: any) => {
      return hasFile;
    }));
  }

  hasFile(): Observable<boolean> {
    const hasFiles$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      select(fromUploader.getAllRawFiles),
      takeUntil(hasFiles$)
    ).subscribe((files: FileSystemMetadata[]) => {
      if (files.length) {
        hasFiles$.next(true);
      } else {
        this.router.navigateByUrl(getPathWithoutLastFragment());
        hasFiles$.next(false);
      }
    });
    return hasFiles$.asObservable();
  }
}
